/**************************************************
 * Nombre:       TextoTitulo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const TextoTitulo = ({texto, titulo, negrita, orientacion = 'flex-start'}) => {

    return (
        <Grid
            container
            justifyContent={orientacion}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: orientacion}}>
                <Typography sx={{fontWeight: 600, fontSize: 14}}>{texto}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: orientacion, mt: -0.5}}>
                <Typography sx={{fontWeight: 400, fontSize: 22}}>{titulo}
                    <span style={{marginLeft: 5, fontWeight: 800}}>{negrita}</span>
                </Typography>
            </Grid>

        </Grid>
    )

}
export default TextoTitulo